// extracted by css-extract-rspack-plugin
export default {"completedBody":"completedBody-ruE8os","statusMessage":"statusMessage-DaHEKi","statusText":"statusText-L910SQ"};